import { ReactNode } from 'react';
import clsx from 'clsx';

export function List({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={clsx('divide-y divide-hairline', className)}>{children}</div>;
}

export function ListItem({ children, onClick, active, className }: { children: ReactNode; onClick?: () => void; active?: boolean; className?: string }) {
  return (
    <div
      onClick={onClick}
      className={clsx(
        'px-2 py-2 transition-colors duration-[120ms]',
        onClick && 'cursor-pointer hover:bg-whisper',
        active && 'bg-whisper',
        className,
      )}
    >{children}</div>
  );
}
